import React, { useState, Component } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2'
import Items from '../items'
import { customClass, getSecondsFromTime, secondsToTime } from '../../../../../../../../utils'
import { RE_ORDER, DELETE_SCENE_CONTENT, updateDuration, updateDurationRequest, UPDATE_STATUS } from "../../../../../../../../actions/sceneActions";

const getListStyle = isDraggingOver => ({
    background: 'none',//isDraggingOver ? "lightblue" : "lightgrey",
    width: '100%'
});

const getItemStyle = (isDragging, draggableStyle, grid) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    // padding: grid * 2,
    margin: `0 0 ${grid}px 0`,

    // change background colour if dragging
    background: isDragging ? "none" : "none",

    // styles we need to apply on draggables
    ...draggableStyle
});

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
}

class SceneDragItem extends Component {
    state = {
        items: []
    }
    componentDidMount() {
        this.onLoadData(this.props);
    }
    onLoadData = (props) => {
        const { data } = props;
        this.setState({ items: data });
    }
    onDragEnd = (result) => {
        const { items } = this.state;
        if (!result.destination) {
            return;
        }
        const itemsNew = reorder(
            items,
            result.source.index,
            result.destination.index
        );
        this.setState({ items: itemsNew }, () => this.onReOrder());
    }
    onReOrder = () => {
        const { items } = this.state;
        let reorderedItems = items.map((i) => i.id)
        if (reorderedItems && reorderedItems.length > 0) this.props.RE_ORDER(reorderedItems)
    }


    callbackScene=(status=0)=>{    
 
         setTimeout(() => {

            const { match, scenes, studio} =this.props;  
            const scenesObj = scenes.scenes.filter(obj=> obj.totalTime>0 && obj.status)

            if(!scenesObj.length && studio.studioWall.is_studio_enabled){
                this.props.UPDATE_STATUS(false,match.params.wallId)
            }

            if(!status){
                toast.success("Scene content has been successfully deleted !", {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }

        }, 1000);
     }

    onDeleteSceneContent = (id) => event => {
        const { sceneID } = this.props;

        Swal.fire({
            title: "Are you sure?",
            text: "You want to delete scene content now?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Delete",
            cancelButtonText: "Back",
            reverseButtons: true,
            customClass: customClass
        }).then((result) => {
            if (result.value) {
                this.props.DELETE_SCENE_CONTENT(id, sceneID, ()=>this.callbackScene())
             }
            else if (result.dismiss === "cancel") {

            }
        });
    }
    onIncreaseUpdateDuration = (id, duration, type) => event => {
        const { sceneID } = this.props;
        let dataTime = secondsToTime(duration)
        if (type == 1) {
            let acrtualTime = dataTime.split(':')
            if (acrtualTime && acrtualTime.length) {
                let dataIncrese = parseInt(acrtualTime[0]) + 1;
                let generateTime = `${dataIncrese}:${acrtualTime[1]}:${acrtualTime[2]}`
                let getTotalSecond = getSecondsFromTime(generateTime);
                this.props.updateDuration(id, getTotalSecond, sceneID)
            }
        }
        else if (type == 2) {
            let acrtualTime = dataTime.split(':')
            if (acrtualTime && acrtualTime.length) {
                let dataIncrese = parseInt(acrtualTime[1]) + 1;
                let generateTime = `${acrtualTime[0]}:${dataIncrese}:${acrtualTime[2]}`
                let getTotalSecond = getSecondsFromTime(generateTime);
                this.props.updateDuration(id, getTotalSecond, sceneID)
            }
        }
        else if (type == 3) {
            let acrtualTime = dataTime.split(':')
            if (acrtualTime && acrtualTime.length) {
                let dataIncrese = parseInt(acrtualTime[2]) + 1;
                let generateTime = `${acrtualTime[0]}:${acrtualTime[1]}:${dataIncrese}`
                let getTotalSecond = getSecondsFromTime(generateTime);
                this.props.updateDuration(id, getTotalSecond, sceneID)
            }
        }



    }
    onDeCreaseUpdateDuration = (id, duration, type) => event => {
        const { sceneID } = this.props;
        // const count = (parseInt(duration) - 1);
        // this.props.updateDuration(id, (count > 0) ? count : 0, sceneID)
        // const { sceneID } = this.props;
        let dataTime = secondsToTime(duration)
        if (type == 1) {
            let acrtualTime = dataTime.split(':')
            if (acrtualTime && acrtualTime.length) {
                let dataIncrese = parseInt(acrtualTime[0]) - 1;
                let generateTime = `${(dataIncrese > 0) ? dataIncrese : 0}:${acrtualTime[1]}:${acrtualTime[2]}`
                let getTotalSecond = getSecondsFromTime(generateTime);
                this.props.updateDuration(id, getTotalSecond, sceneID)
            }
        }
        else if (type == 2) {
            let acrtualTime = dataTime.split(':')
            if (acrtualTime && acrtualTime.length) {
                let dataIncrese = parseInt(acrtualTime[1]) - 1;
                let generateTime = `${acrtualTime[0]}:${(dataIncrese > 0) ? dataIncrese : 0}:${acrtualTime[2]}`
                let getTotalSecond = getSecondsFromTime(generateTime);
                this.props.updateDuration(id, getTotalSecond, sceneID)
            }
        }
        else if (type == 3) {
            let acrtualTime = dataTime.split(':')
            if (acrtualTime && acrtualTime.length) {
                let dataIncrese = parseInt(acrtualTime[2]) - 1;
                let generateTime = `${acrtualTime[0]}:${acrtualTime[1]}:${(dataIncrese > 0) ? dataIncrese : 0}`
                let getTotalSecond = getSecondsFromTime(generateTime);
                this.props.updateDuration(id, getTotalSecond, sceneID)
            }
        }


    }
    onMouseOutUpdateDuration = (id, duration) => event => {
        //convertHMS()
        const { sceneID } = this.props;
        this.props.updateDurationRequest(id, duration, ()=>this.callbackScene(1))
    }

    onChangeDuration = (id, duration) => event => {
        const { sceneID } = this.props;
        this.props.updateDuration(id, getSecondsFromTime(event.target.value), sceneID)
    }
    componentWillReceiveProps(nextProps) {
        this.onLoadData(nextProps);
    }
    render() {
        const { items } = this.state;
        const { onIncreaseTime, onDecreaseTime, duration, match, sceneID, history } = this.props;

        return <DragDropContext onDragEnd={this.onDragEnd} style={{ background: 'none', width: '100%' }
        } className={'test'} >
            <Droppable droppableId="droppableScenes" style={{ background: 'none', width: '100%' }}>
                {(provided, snapshot) => (
                    <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        style={getListStyle(snapshot.isDraggingOver)}
                    >
                        {items.map((item, index) => {

                            return <Draggable key={item.id} draggableId={`draggableId${item.id}`} index={index}>
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style,
                                            items.length
                                        )}
                                    >
                                        <Items history={history} itemKeyID={index + 1} sceneID={sceneID} onDeleteSceneContent={this.onDeleteSceneContent} item={item} onIncreaseTime={onIncreaseTime} onDecreaseTime={onDecreaseTime} duration={duration} match={match} onIncreaseUpdateDuration={this.onIncreaseUpdateDuration} onDeCreaseUpdateDuration={this.onDeCreaseUpdateDuration} onMouseOutUpdateDuration={this.onMouseOutUpdateDuration} onChangeDuration={this.onChangeDuration} />
                                    </div>
                                )}
                            </Draggable>
                        })}
                    </div>)}
            </Droppable>
        </DragDropContext >

    }
}

const mapStateToProps = state => {
    return {
        scenes: state.scene,
        studio : state.studio
    }
}
const mapDispatchToProps = dispatch => {
    return {
        RE_ORDER: (reorderedItems) => dispatch(RE_ORDER(reorderedItems)),
        DELETE_SCENE_CONTENT: (reorderedItems, sceneID, callbackScene) => dispatch(DELETE_SCENE_CONTENT(reorderedItems, sceneID, callbackScene)),
        updateDuration: (contentId, duration, sceneID) => dispatch(updateDuration(contentId, duration, sceneID)),
        UPDATE_STATUS: (status,wallId) => dispatch(UPDATE_STATUS(status,wallId)),
        updateDurationRequest: (contentId, duration, callbackScene) => dispatch(updateDurationRequest(contentId, duration, callbackScene)),


    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SceneDragItem);